<div class="main-container" data-cy="patient-portal-reschedule-main-container">

  <div class="main-title" data-cy="patient-portal-reschedule-title">
    Please provide a reason for rescheduling:
  </div>

  <div class="reason-input" data-cy="patient-portal-reschedule-reason-container">
    <div style="flex: 1; padding: 4px; background-color: rgba(0, 0, 0, 0.05); border-radius: var(--border-radius);" data-cy="patient-portal-reschedule-reason-input-container">
      <textarea placeholder="Type your reason here..."
        style="height: 100%; width: 100%; outline: unset; border: unset; resize: none; background-color: unset;"
        [(ngModel)]="reasonText" data-cy="patient-portal-reschedule-reason-input"></textarea></div>
      
  </div>

  <div class="action-container" data-cy="patient-portal-reschedule-action-container">
    <button mat-button class="action-button tdo-close" color="warn" (click)="close(false)" data-cy="patient-portal-reschedule-cancel-button">Cancel</button>
    <button mat-raised-button class="action-button tdo-save" color="primary" (click)="close(true)"
      [disabled]="!reasonText" data-cy="patient-portal-reschedule-confirm-button">Confirm</button>
  </div>

</div>